export default "__VITE_ASSET__b1d8a3f8__"